import { connect } from 'react-redux'
import Button from 'components/Shared/Button'
import MenuControl from 'components/Editor/Inspect/Libraries/MenuControl'
import Icon from 'components/Shared/Icon'
import { App } from 'ducks/apps'
import { useEffect, useState } from 'react'

type AppOrientationProps = {
  app: App
  onSubmit: (value: string) => void
}

const AppOrientationSettings: React.FC<AppOrientationProps> = props => {
  const { app, onSubmit } = props
  const { orientation = 'both' } = app
  const [value, setValue] = useState<'portrait' | 'landscape' | 'both'>('both')

  const label = 'How should users view this app?'
  const options = [
    { label: 'Portrait Only', value: 'portrait' },
    { label: 'Landscape Only', value: 'landscape' },
    { label: 'Both Portrait & Landscape', value: 'both' },
  ]

  const orientationLabels: Record<'portrait' | 'landscape' | 'both', string> = {
    portrait: 'Portrait Only',
    landscape: 'Landscape Only',
    both: 'Both Portrait & Landscape',
  }
  const buttonText = `Save as ${orientationLabels[value]}`

  useEffect(() => {
    if (orientation) {
      setValue(orientation)
    }
  }, [orientation])

  const onChange = ({
    orientation: newValue,
  }: {
    orientation: 'portrait' | 'landscape' | 'both'
  }): void => {
    setValue(newValue)
  }

  const onClick = (): void => {
    onSubmit(value)
  }

  const buttonDisabled = orientation === value

  return (
    <div className="app-layout-settings">
      <MenuControl
        displayName={label}
        options={options}
        value={value}
        onChange={onChange}
        name="orientation"
      />
      <div className="mobile-layout-help-text-container">
        <div className="mobile-layout-help-header">
          <Icon type="help-text" />
          <h2>Helpful Tip</h2>
        </div>
        <h3>What happens when you change the app orientation?</h3>
        <p>
          Changing the app orientation will affect how users can view and
          interact with your app on their devices. This setting helps ensure the
          best user experience based on your app's design.
        </p>
      </div>
      <Button
        outlined={buttonDisabled}
        disabled={buttonDisabled}
        teal={!buttonDisabled}
        onClick={onClick}
      >
        {buttonText}
      </Button>
    </div>
  )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {})(AppOrientationSettings)
